<script setup>
import {Button, InputGroup, InputGroupAddon, InputText, Textarea} from "primevue";
import {
  Dialog,
  DialogOverlay,
  DialogPanel,
  TransitionChild,
  TransitionRoot
} from "@headlessui/vue";
import {Icon} from "@iconify/vue";
import {computed, ref} from "vue"
import {useUserStore} from "@/stores/user.js";

const userStore = useUserStore();

const props = defineProps({
  hotOrder: {type: Object, required: true}
})
const emit = defineEmits(['closeModal']);
/* ---------- Loading status ---------- */
const loading = ref(true)
const saving = ref(false)

const users = computed(() => userStore.getAllUsers || [])

const userMap = computed(() => {
  return users.value.reduce((map, user) => {
    map[user.id] = user.name || user.username || "Unknown"
    return map
  }, {})
})

function closeModal() {
  emit('closeModal');
}

const formatText = (text) => {
  return text?.replace(/\n/g, '<br>') || ''
}
</script>

<template>
  <TransitionRoot appear show as="template">
    <Dialog as="div" @close="closeModal" class="relative z-[999]">
      <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >
        <DialogOverlay class="fixed inset-0 bg-[black]/60"/>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex h-full overflow-hidden items-center justify-center px-4 py-8">
          <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
          >
            <DialogPanel
                class="w-full flex flex-col overflow-hidden rounded-md max-w-2xl max-h-full text-left align-middle shadow-xl transition-all bg-white dark:bg-[#0e1726] text-black-600 dark:text-white">
              <div class="max-h-full flex flex-col overflow-hidden">
                <div class="flex flex-row gap-4 justify-between px-4 border-b border-slate-700">
                  <div class="flex-1 flex flex-row justify-between items-center">
                    <div class="text-sm py-3">
                      Taker : {{ hotOrder.id }}
                    </div>
                  </div>
                  <div class="flex flex-row items-center gap-4">
                    <div class="h-full w-[1px] bg-slate-700"></div>
                    <button
                        type="button"
                        class="text-white-dark outline-none hover:text-red-500"
                        @click="closeModal"
                    >
                      <Icon icon="pajamas:close-xs"/>
                    </button>
                  </div>
                </div>
                <div class="p-4 flex-1 overflow-hidden max-h-full flex flex-col gap-4">
                  <div class="grid grid-cols-2 gap-2 justify-between">
                    <div class="flex flex-col text-sm">
                      <span>Title:</span>
                      <span class="p-2 bg-slate-800 rounded-md">{{ hotOrder.title }}</span>
                    </div>
                    <div class="flex flex-col text-sm">
                      <span>Taker:</span>
                      <span class="p-2 bg-slate-800 rounded-md">{{ hotOrder.takerName }}</span>
                    </div>
                  </div>
                  <div class="flex-1 flex flex-col text-sm overflow-hidden gap-0.5">
                    <span>Logs:</span>
                    <div class="p-2 rounded-md bg-slate-800 overflow-y-auto">
                      <p class="pr-2 break-all" v-html="formatText(hotOrder.logs)"></p>
                    </div>
                  </div>
                </div>
                <!--                <div class="px-3 pb-3 pt-3 flex justify-end gap-3">
                                  <button @click="closeModal" class="btn btn-outline-primary py-1 flex flex-row gap-2 px-2">
                                    Close
                                  </button>
                                </div>-->
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<style scoped lang="scss">

</style>